<template>
  	<PinListBatchWise />
</template>

<script>

// @ is an alias to /src
import PinListBatchWise from "@/components/PinListBatchWise.vue";

export default {
  name: "PinListBatchWises",
  components: {
    PinListBatchWise,
  },
};
</script>
